import { useSelector } from "react-redux";
import {
	getFormHasError,
	getFormIsBeingSubmitted,
	getFormIsSubmitted,
	getRedirectAllowed,
	getUserExists,
} from "./selectors";

export default function useFormState() {
	const error = useSelector(getFormHasError);
	const loading = useSelector(getFormIsBeingSubmitted);
	const redirect = useSelector(getRedirectAllowed);
	const success = useSelector(getFormIsSubmitted);
	const userExists = useSelector(getUserExists);

	return {
		error,
		loading,
		redirect,
		success,
		userExists,
	};
}
